import { render } from "./MinusSquareIcon.vue?vue&type=template&id=2b308193"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__